<template>
  <div
    class="flex space_mono card_container bg_white_4 overflow-hidden"
    :style="{ height: `${height}px` }"
  >
    <div
      class="html_code_editor_line_numbers flex flex-col pl-3 py-2 min-w-[30px] text-left select-none overflow-hidden"
    >
      <div
        v-for="lineNumber in lineCount"
        :key="lineNumber"
        class="secondary_color text-[12px] font-normal"
        style="line-height: 1.57"
      >
        {{ lineNumber }}
      </div>
    </div>
    <a-textarea
      ref="codeTextarea"
      v-model:value="internalValue"
      class="text_color space_mono flex-1 border-none outline-none bg-transparent resize-none px-3 py-2 text-[12px] leading-normal font-normal whitespace-pre overflow-x-auto"
      :placeholder="placeholder"
      @input="handleInput"
      @scroll="handleScroll"
      @keydown="handleKeydown"
      :auto-size="false"
      :bordered="false"
      :show-count="false"
      style="tab-size: 2; overflow-wrap: normal"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "Enter HTML code here...",
  },
  height: {
    type: Number,
    default: 300,
  },
});

const emit = defineEmits(["update:modelValue"]);

const codeTextarea = ref(null);
const internalValue = ref(props.modelValue);

const lineCount = computed(() => {
  const lines = internalValue.value.split("\n");
  return Math.max(lines.length, 1);
});

const handleInput = () => {
  emit("update:modelValue", internalValue.value);
};

const handleScroll = (event) => {
  const lineNumbers = document.querySelector(".html_code_editor_line_numbers");
  if (lineNumbers && event.target) {
    lineNumbers.scrollTop = event.target.scrollTop;
  }
};

const handleKeydown = (event) => {
  if (event.key === "Tab") {
    event.preventDefault();
    const textarea = event.target;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const spaces = "  ";
    internalValue.value =
      internalValue.value.substring(0, start) +
      spaces +
      internalValue.value.substring(end);

    nextTick(() => {
      textarea.selectionStart = textarea.selectionEnd = start + spaces.length;
    });

    emit("update:modelValue", internalValue.value);
  }
};

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== internalValue.value) {
      internalValue.value = newValue;
    }
  },
);

onMounted(() => {
  if (props.modelValue) {
    internalValue.value = props.modelValue;
  }
});
</script>

<style scoped>
:deep(.ant-input) {
  outline: none !important;
}
</style>
